import { render, staticRenderFns } from "./stepper-footer.vue?vue&type=template&id=2185deb6&scoped=true&"
import script from "./stepper-footer.vue?vue&type=script&lang=ts&"
export * from "./stepper-footer.vue?vue&type=script&lang=ts&"
import style0 from "./stepper-footer.vue?vue&type=style&index=0&id=2185deb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2185deb6",
  null
  
)

export default component.exports